/* istanbul ignore file */

export function scrollNearestScrollableParent(element, padding = 32) {
    let target = element.parentElement;

    while (target && target.scrollHeight <= target.clientHeight) {
        target = target.parentNode;
    }

    target.scrollTo(0, element.offsetTop - padding);
}
